import React from "react";

// The signature PM Test Score badge. size: "sm" | "md" | "lg"
export function ScoreBadge({ score, passes, threshold = 70, size = "md", unscored }) {
  const isUnscored = unscored || score == null;
  const dims = {
    sm: { box: "w-16", num: "text-2xl", label: "text-[8px]" },
    md: { box: "w-24", num: "text-4xl", label: "text-[9px]" },
    lg: { box: "w-40", num: "text-7xl", label: "text-xs" },
  }[size];

  if (isUnscored) {
    return (
      <div data-testid="score-badge-unscored"
        className={`inline-flex flex-col border-2 border-stone-900 ${dims.box} bg-stone-200`}>
        <div className={`font-mono-pm ${dims.num} font-black text-stone-900 text-center py-2 leading-none`}>—</div>
        <div className={`font-mono-pm ${dims.label} font-bold tracking-widest uppercase text-center py-1.5 border-t-2 border-stone-900 bg-stone-900 text-stone-200`}>
          Not Yet Scored
        </div>
      </div>
    );
  }

  const pass = passes ?? score >= threshold;
  return (
    <div data-testid="score-badge"
      className={`inline-flex flex-col border-2 border-stone-900 ${dims.box} ${pass ? "bg-stone-900" : "bg-[#991B1B]"}`}>
      <div className={`font-mono-pm ${dims.num} font-black text-center py-2 leading-none ${pass ? "text-[#CCFF00]" : "text-white"}`}>
        {score}
      </div>
      <div className={`font-mono-pm ${dims.label} font-bold tracking-[0.15em] uppercase text-center py-1.5 border-t-2 border-stone-900 ${pass ? "bg-[#CCFF00] text-stone-900" : "bg-white text-[#991B1B]"}`}>
        {pass ? "Passes" : "Does Not Pass"}
      </div>
    </div>
  );
}
